<template>
  <v-btn
    v-if="broadcastTeacher"
    fab
    small
    :color="setActivePinColor('button')"
    :style="pinIconStyle()"
    @click="pinInteractionForBroadcast"
  >
    <v-icon
      size="16"
      :color="setActivePinColor('icon')"
      :style="{
        height: 'auto'
      }"
    >
      push_pin
    </v-icon>
  </v-btn>
</template>

<script>
/* global _ */
/* global moment */
import { mapGetters } from 'vuex';
import { triggerInteractionItems } from '@/js/firestore-utils';
export default {
  name: 'broadcast-pin',
  components: {  },
  props: [
    'interactionId',
    'isDiscussionType',
  ],
  computed: {
    ...mapGetters('player', [
      'broadcastActiveInteractionId',
      'broadcastId',
      'broadcastTeacher',
      'displayTime',
      'user',
    ]),
  },
  methods: {
    setActivePinColor(type) {
      if(type === 'button')
        return this.broadcastActiveInteractionId === this.interactionId ? 'primary' : 'white';
      else if(type === 'icon')
        return this.broadcastActiveInteractionId === this.interactionId ? 'white' : 'black';
    },
    pinInteractionForBroadcast() {
      if(this.broadcastActiveInteractionId === this.interactionId)
        triggerInteractionItems(this.broadcastId, this.displayTime, null);
      else
        triggerInteractionItems(this.broadcastId, this.displayTime, this.interactionId);
    },
    pinIconStyle() {
      if(this.isDiscussionType) {
        return {
          'position':'absolute',
          'right':'5px'
        };
      }
      return {
        'float': 'right',
      };
    },
  },
};
</script>
